import React, { Component } from "react";
import { Input, Measurement, MeasurementList } from "../../../../../form-inputs/inputs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import { DEFAULT_RANGE } from "./lib/constant";
import { EMPTY_DOLLAR } from "../../../../../../shared/typeahead-prefill";

class Range extends Component {
    constructor(props) {
        super();
        const range = props.range || {};

        this.state = {
            ...DEFAULT_RANGE,
            ...range,
        };
    }

    static getDerivedStateFromProps(nextProps) {
        return {
            ...nextProps.range,
        };
    }

    updateState = (key, value) => {
        this.setState({
            [key]: value,
        });

        const payload = { ...this.props.range, [key]: value };
        this.props.updateRange(this.props.id, payload);
    };

    render() {
        const addRanges =
            this.state.low || this.state.high ? (
                <div className="range-label">
                    <div className="vertical-text">Ranges</div>
                    <div className="input-group">
                        <Measurement label="Low" name="low" defaultValue={this.state.low} updateOnChange={this.updateState} />
                        <Measurement label="High" name="high" defaultValue={this.state.high} updateOnChange={this.updateState} />
                    </div>
                    <div className="input-group">
                        <Input label="Label" name="label" value={this.state.label} updateOnChange={this.updateState} className="-full" />
                        <Input
                            label="Label Range"
                            name="labelRange"
                            value={this.state.labelRange}
                            updateOnChange={this.updateState}
                            className="-full"
                        />
                    </div>
                </div>
            ) : null;

        return (
            <div className="range-container">
                <div className="range-title">
                    <h3>Slider Range </h3>
                    <div>
                        <button
                            className="button -small -error"
                            onClick={() => {
                                this.props.delete(this.props.id);
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} />
                        </button>
                    </div>
                </div>
                <Input label="Slider Title" name="sliderTitle" value={this.state.sliderTitle} updateOnChange={this.updateState} />
                <div className="selected-value">
                    <div>
                        <MeasurementList
                            label="Selected Value"
                            name="selectedValue"
                            value={this.state.selectedValue}
                            updateOnChange={this.updateState}
                            prefill={EMPTY_DOLLAR}
                        />
                    </div>
                </div>

                {addRanges}
                <Input label="Legend Text" name="legendText" value={this.state.legendText} updateOnChange={this.updateState} />
            </div>
        );
    }
}

export default Range;
